module.exports = __webpack_public_path__ + "img/get-app-id.40e78ba.png";